// // ─── Contact ─────────────────────────────────────────────────────────────────

// import { useState } from "react";

// export default function Contact() {
//   const [sent, setSent] = useState(false);
//   const [form, setForm] = useState({
//     name: "", company: "", email: "", country: "", message: "",
//   });

//   function handle(e) {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   }

//   function submit(e) {
//     e.preventDefault();
//     setSent(true);
//   }

//   return (
//     <section className="section contact" id="contact">
//       <div className="container contact__inner">
//         <div className="contact__info">
//           <span className="section__label">Let's Talk</span>
//           <h2 className="section__title">Contact Us</h2>
//           <p>
//             Whether you're a buyer, distributor, or logistics partner — we'd
//             love to explore opportunities together.
//           </p>
//           <div className="contact__details">
//             <div className="contact__detail">
//               <span className="contact__icon">📍</span>
//               <span>Calgary, Alberta, Canada</span>
//             </div>
//             <div className="contact__detail">
//               <span className="contact__icon">✉️</span>
//               <span>contact@celestialgrains.ca</span>
//             </div>
//             <div className="contact__detail">
//               <span className="contact__icon">📞</span>
//               <span>+1 (403) 555-0192</span>
//             </div>
//           </div>
//           <img
//             src="https://images.unsplash.com/photo-1499529112087-3cb3b73cec95?w=600&q=80"
//             alt="Calgary skyline"
//             className="contact__city-img"
//           />
//         </div>
//         <div className="contact__form-wrap">
//           {sent ? (
//             <div className="contact__thanks">
//               <span className="contact__thanks-icon">🌾</span>
//               <h3>Thank you, {form.name}!</h3>
//               <p>Our team will reach out within one business day.</p>
//             </div>
//           ) : (
//             <form className="contact__form" onSubmit={submit}>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Full Name</label>
//                   <input
//                     name="name"
//                     value={form.name}
//                     onChange={handle}
//                     placeholder="Jane Doe"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Company</label>
//                   <input
//                     name="company"
//                     value={form.company}
//                     onChange={handle}
//                     placeholder="Acme Imports Ltd."
//                   />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Email</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={form.email}
//                     onChange={handle}
//                     placeholder="jane@company.com"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Country</label>
//                   <input
//                     name="country"
//                     value={form.country}
//                     onChange={handle}
//                     placeholder="India"
//                   />
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label>Message / Product Interest</label>
//                 <textarea
//                   name="message"
//                   value={form.message}
//                   onChange={handle}
//                   rows={5}
//                   placeholder="I'm interested in red lentils — 40 MT / month..."
//                   required
//                 />
//               </div>
//               <button type="submit" className="btn btn--gold btn--full">
//                 Send Enquiry
//               </button>
//             </form>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// }

import { useState } from "react";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    company: "",
    email: "",
    country: "",
    phone: "",
    inquiry_type: "",
    message: "",
  });

  function handle(e) {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  }

  async function submit(e) {
    e.preventDefault();

    try {
      setLoading(true);
      const submittedDate = new Date().toLocaleString("en-CA", {
        timeZone: "America/Toronto",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      await emailjs.send(
        "service_olmvuy9",
        "template_ga5tqnx",
        {
          from_name: form.name,
          company: form.company,
          from_email: form.email,
          country: form.country,
          inquiry_type: form.inquiry_type,
          phone: form.phone,
          message: form.message,
          date: submittedDate,
        },
        "yfyvInMCRnTLc3B3w"
      );

      await emailjs.send(
        "service_olmvuy9",
        "template_ukh193s",
        {
          from_name: form.name,
          company: form.company,
          from_email: form.email,
          country: form.country,
          inquiry_type: form.inquiry_type,
          phone: form.phone,
          message: form.message,
          date: submittedDate,
        },
        "yfyvInMCRnTLc3B3w"
      );

      setSent(true);

      setForm({
        name: "",
        company: "",
        email: "",
        country: "",
        phone: "",
        inquiry_type: "",
        message: "",
      });
    } catch (err) {
      console.error(err);
      alert("Failed to send enquiry");
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="section contact" id="contact">
      <div className="container contact__inner">
        <div className="contact__info">
          <span className="section__label">Let's Talk</span>
          <h2 className="section__title">Contact Us</h2>

          <p>
            Whether you're a buyer, distributor, or logistics partner — we'd
            love to explore opportunities together.
          </p>
          <div className="contact__details">
            <div className="contact__detail">
              <span className="contact__icon">📍</span>
              <span>Calgary, Alberta, Canada</span>
            </div>
            <div className="contact__detail">
              <span className="contact__icon">✉️</span>
              <span>sales@celestialgrains.ca</span>
            </div>
            <div className="contact__detail">
              <span className="contact__icon">📞</span>
              <span>+1 (403) 497-9816</span>
            </div>
          </div>
        </div>

        <div className="contact__form-wrap">
          {sent ? (
            <div className="contact__thanks">
              <span className="contact__thanks-icon">🌾</span>

              <h3>Thank you, {form.name}!</h3>

              <p>
                Our team will reach out within one business day.
              </p>
              <button
                type="submit"
                className="btn btn--gold btn--full"
                onClick={() => setSent(false)}
              >
                Send Another Message ?
              </button>

            </div>
          ) : (
            <form className="contact__form" onSubmit={submit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Full Name</label>

                  <input
                    name="name"
                    value={form.name}
                    onChange={handle}
                    placeholder="Jane Doe"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Company</label>

                  <input
                    name="company"
                    value={form.company}
                    onChange={handle}
                    placeholder="Acme Imports Ltd."
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Email</label>

                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handle}
                    placeholder="jane@company.com"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Phone</label>

                  <input
                    name="phone"
                    value={form.phone}
                    onChange={handle}
                    placeholder="+1 555 123 4567"
                  />
                  <small className="text-muted">
                    Include country code (e.g. +1, +44, +91)
                  </small>
                </div>
              </div>


              <div className="form-row">
                <div className="form-group">
                  <label>Inquiry type</label>

                  <select
                    name="inquiry_type"
                    value={form.inquiry_type}
                    onChange={handle}
                    required
                  >
                    <option>-Select-</option>
                    <option>General Inquiry</option>
                    <option>Bulk Order</option>
                    <option>Export Inquiry</option>
                    <option>Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Country</label>

                  <input
                    name="country"
                    value={form.country}
                    onChange={handle}
                    placeholder="India"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Message / Product Interest</label>

                <textarea
                  name="message"
                  value={form.message}
                  onChange={handle}
                  rows={5}
                  placeholder="I'm interested in red lentils — 40 MT / month..."
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn--gold btn--full"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Enquiry"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}